import { DomainForm } from "src/api";
import { FieldsData } from "../types";
import { Field } from "@lib/shared/types";

export const useFields = (
    form: DomainForm,
): {
    fields: FieldsData;
} => {
    const temp: FieldsData = {};

    form.steps.forEach((step) => {
        step.fields.forEach((field: Field) => {
            temp[field.codeName] = {
                value: field.defaultValue ?? "",
                valid: true,
                errorMessage: "",
                changed: false,
                fieldType: field.fieldType,
                meta: field.meta,
            };
        });
    });
    return { fields: temp };
};
